import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { setupKeys } from "@/shared/lib/queryKeys";
import { SETUP_POLL_MS } from "../setup.config";

export const nextRaidQueryOptions = queryOptions({
  queryKey: setupKeys.next,
  queryFn: async () => unwrap(await api.GET("/api/setup/next")),
});

// All raid days for the raid-switcher dropdown. The list only changes when a
// raid day is created/edited — and those mutations invalidate setupKeys — so a
// long staleTime stops the default refetch on every window refocus.
export const raidsQueryOptions = queryOptions({
  queryKey: setupKeys.raids,
  queryFn: async () => unwrap(await api.GET("/api/setup/raids")),
  staleTime: 5 * 60_000,
});

// Polls while mounted so other officers' edits appear without a save/refresh cycle.
export function setupQueryOptions(raidId: string) {
  return queryOptions({
    queryKey: setupKeys.byRaid(raidId),
    queryFn: async () =>
      unwrap(
        await api.GET("/api/setup/{raidId}", {
          params: { path: { raidId } },
        }),
      ),
    refetchInterval: SETUP_POLL_MS,
  });
}
